<div class="eui-app-sidebar-header-user-profile-content" (click)="onProfileClick($event)">
    <div class="eui-user-profile__avatar" [ngClass]="isOnline ? 'eui-user-profile__avatar--online' : 'eui-user-profile__avatar--offline'"></div>

    <div class="eui-user-profile__infos">

        <!-- NORMAL LOGIN-->
        <div *ngIf="!(asServie.state$ | async)?.impersonatedUserInfos" class="eui-user-profile__infos-wrapper">
            <div *ngIf="welcomeLabel" class="eui-user-profile__infos-welcome">{{welcomeLabel}}</div>
            <div class="eui-user-profile__infos-container">
                <span class="eui-user-profile__infos-name">{{(asServie.state$ | async)?.userInfos}}</span>
            </div>
        </div>

        <!-- IMPERSONATION -->
        <div *ngIf="(asServie.state$ | async)?.impersonatedUserInfos" class="eui-user-profile__infos-wrapper">
            <div class="eui-user-profile__infos-container">
                <span *ngIf="welcomeLabel" class="eui-user-profile__infos-welcome">{{welcomeLabel}}&nbsp;</span>
                <span class="eui-user-profile__infos-welcome"><strong>{{(asServie.state$ | async)?.userInfos}}</strong></span>
            </div>
            <div class="eui-user-profile__infos-container">
                <span class="eui-user-profile__infos-impersonating">{{impersonateLabel}}&nbsp;</span>
                <span class="eui-user-profile__infos-name">{{(asServie.state$ | async)?.impersonatedUserInfos}}</span>
            </div>
        </div>

        <!-- SUB INFOS-->
        <div *ngIf="(asServie.state$ | async)?.userSubInfos" class="eui-user-profile__infos-subinfos">
            {{(asServie.state$ | async)?.userSubInfos}}
        </div>
    </div>

    <button euiButton euiRounded euiIconButton euiSizeS euiBasicButton euiSecondary class="eui-user-profile__toggle">
        <span class="eui-icon" [ngClass]="toggleProfile ? 'eui-icon-angle-up' : 'eui-icon-angle-down'"></span>
    </button>
</div>

